<template>
  <!-- Modální Dialog -->
  <div v-if="hasNewVersion.value" class="fixed inset-0 bg-gray-900 bg-opacity-80 flex items-center justify-center z-50 p-4 backdrop-blur-sm transition-opacity duration-300">
    <div class="bg-white rounded-xl shadow-2xl p-6 w-full max-w-sm transform transition-all duration-300 scale-100 border-t-4 border-[#064f32]">
      <div class="text-center">
        <img src="../assets/img/krnaplogo_100px.png" alt="Logo KRNAP" loading="lazy" class="mx-auto" />

        <h3 class="mt-4 text-xl leading-6 font-bold text-gray-900">Nová verze je k dispozici</h3>
        <div class="mt-2">
          <p class="text-sm text-gray-500">
            Byla nalezena verze <span class="font-semibold text-[#064f32]">{{ hasNewVersion.value }}</span>. Pro správné fungování prosím aplikaci restartujte.
          </p>
          <p class="text-xs text-gray-500 mt-3">
            Nepomohlo načtení nové verze?<br />Zkuste prosím vymazat cache pro doménu krnap.cz ve svém webovém prohlížeči.
          </p>
          <p class="text-xs text-gray-400 mt-3">
            Aktuálně načtená verze aplikace je {{ actualAppVersion }}.
          </p>
        </div>
      </div>
      <div class="mt-6 space-y-3">
        <button 
          @click="hardReload(true)" 
          type="button" 
          class="w-full inline-flex justify-center rounded-lg shadow-lg px-4 py-3 bg-[#064f32] text-base font-semibold text-white hover:bg-[#064f32] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#064f32] transition duration-150 ease-in-out transform hover:scale-[1.01]"
        >
          Načíst novou verzi
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config/config'

export default {
  name: 'AppVersionModal',
  inject: ['hasNewVersion'],
  data() {
    return {
      actualAppVersion: config.appVersion
    }
  },
  methods: {
    hardReload() {
      console.log('Provádím HARD RELOAD...');
      if (typeof localStorage !== 'undefined') {
            localStorage.clear();
      }
      window.location.href = window.location.pathname + '?timestamp=' + new Date().getTime();
    }
  }
}
</script>
